exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.mt4[data-v-4082745c] {\n  margin-top: 4px;\n}\n.mt5[data-v-4082745c] {\n  margin-top: 5px;\n}\n.mt10[data-v-4082745c] {\n  margin-top: 10px;\n}\n.mb9[data-v-4082745c] {\n  margin-bottom: 9px;\n}\n.task-input-users[data-v-4082745c] {\n  background-color: white;\n}\n.task-cancel-button[data-v-4082745c] {\n  min-width: 150px;\n}\n.task-save-button[data-v-4082745c] {\n  margin-left: 10px;\n  float: right;\n  min-width: 150px;\n}\n", ""]);

// exports
